<template>
  <div v-loading="loading" style="padding: 30px;">
    <el-card>
      <div style="text-align: center;">
        <el-button type="text" @click="viewCoupon()" style="margin: 30px 0; font-size: 26px;">
          {{ this.couponData.title }}
        </el-button>
      </div>
      <el-table :data="couponDataTable" border style="width: 100%;">
        <el-table-column align="center" prop="count" :label="generateCustomizeString('couponTotalNumber')"></el-table-column>
        <el-table-column align="center" prop="get_count" :label="generateCustomizeString('numberOfCollect')"></el-table-column>
        <el-table-column align="center" prop="used_count" :label="generateCustomizeString('numberOfUsed')"></el-table-column>
        <el-table-column align="center" prop="avg_order_fee" :label="generateCustomizeString('averagePrice')">
          <template slot-scope="scope">
            <span>NZD ${{scope.row.avg_order_fee}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="total_order_fee" :label="generateCustomizeString('sumOfOrder')">
          <template slot-scope="scope">
            <span>NZD ${{scope.row.total_order_fee}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>{{generateCustomizeString('couponOrder')}}</span>
      </div>
      <el-table :data="couponOrderData" style="width: 100%;">
        <el-table-column prop="out_trade_no" :label="generateCustomizeString('orderId')">
          <template slot-scope="scope">
            <el-button
              @click="viewOrderClick(scope.row)"
              type="text"
            >{{scope.row.out_trade_no}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" :label="generateCustomizeString('orderCreateAt')">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at | toLocalTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fee" :label="generateCustomizeString('priceOfOrder')">
          <template slot-scope="scope">
            <span>NZD ${{ parseFloat((scope.row.fee * 100) / 10000).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customer_name" :label="generateCustomizeString('customerId')">
          <template slot-scope="scope">
            <el-button
              @click="viewCustomer(scope.row)"
              type="text"
            >{{scope.row.customer_name}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px; padding: 5px; background-color: #f2f2f2;">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="numOfCouponOrders" layout="total, prev, pager, next" :total="currentTotal">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'CouponStatistics',
  data() {
    return {
      loading: false,
      couponData: {},
      couponDataTable: [],
      couponOrderData: [],
      currentPage: 1,
      currentTotal: 0,
      numOfCouponOrders: 15
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchCouponOrderList(this.currentPage)
    },
    viewCoupon() {
      this.$router.push({
        name: 'EditCoupon',
        params: { couponId: this.couponData.id }
      })
    },
    viewOrderClick(row) {
      this.$router.push({
        name: 'OrderView',
        params: { orderId: row.id }
      })
    },
    viewCustomer(row) {
      this.$router.push({
        name: 'MemberView',
        params: { memberId: row.customer.id }
      })
    },
    fetchCouponInfo() {
      this.loading = true
      request({
        url: 'coupon/statinfo/' + this.$route.params.couponId,
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            this.couponData = res.data.coupon
            this.couponData.avg_order_fee = parseFloat((res.data.avg_order_fee * 100) / 10000).toFixed(2)
            this.couponData.total_order_fee = parseFloat((res.data.total_order_fee * 100) / 10000).toFixed(2)
            this.couponDataTable.push(this.couponData)
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchCouponOrderList(page) {
      request({
        url: '/coupon/order/list?coupon_id=' + this.$route.params.couponId,
        method: 'get',
        params: {
          page: page,
          page_size: this.numOfCouponOrders
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          this.couponOrderData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
    },
    handleCurrentChange(val) {
      this.fetchCouponOrderList(val)
    }
  },
  created: function() {
    this.fetchCouponInfo()
    this.fetchCouponOrderList()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both
}
</style>
